let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l7eUn")).then(() => parcelRequire('bJ3uV'));